var map = {
	"./browser-notice.de-CH.json": 961,
	"./browser-notice.de-DE.json": 962,
	"./browser-notice.en-CA.json": 963,
	"./browser-notice.en-GB.json": 964,
	"./browser-notice.en-IN.json": 965,
	"./browser-notice.en-ME.json": 966,
	"./browser-notice.en-US.json": 967,
	"./browser-notice.es-EM.json": 968,
	"./browser-notice.es-ES.json": 969,
	"./browser-notice.fr-BE.json": 970,
	"./browser-notice.fr-CA.json": 971,
	"./browser-notice.fr-CH.json": 972,
	"./browser-notice.nl-BE.json": 973,
	"./browser-notice.nl-NL.json": 974,
	"./browser-notice.pl-PL.json": 975,
	"./browser-notice.pt-BR.json": 976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;